import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import classes from './NgzPageNotFound.module.scss';
import { angularizeWithProviders } from '../../providers';
import pageNotFoundImg from '../../assets/image/pageNotFoundImg.png';
import { goToHomePage } from '../../utils/angularUtils';
import { supportEmail, supportEmailHref } from '../../constants/supportEmail';

const NgzPageNotFound = () => {
  return (
    <div className={classes.box}>
      <img src={pageNotFoundImg} alt="page not found" />
      <div className={classes.textBox}>
        <p>
          The page you were looking for is taking a break and is no longer available. If
          you need more help please let us know at&nbsp;
          <a href={supportEmailHref}>{supportEmail}</a>. Thank you.
        </p>
      </div>
      <Button variant="contained" onClick={goToHomePage}>
        Return to the Main page
      </Button>
    </div>
  );
};

angularizeWithProviders(NgzPageNotFound, 'ngzPageNotFound', {});

export { NgzPageNotFound };
